export default __webpack_public_path__ + "static/media/rputer.48455a0b.png";